"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadContext = void 0;
var _react = require("react");
var UploadContext = exports.UploadContext = /*#__PURE__*/(0, _react.createContext)({
  open: function open() {},
  isDragging: false,
  getDraggerProps: function getDraggerProps() {
    return {};
  }
});